import { motion } from "framer-motion";

// Icons
import { ArrowRightIcon } from "@heroicons/react/24/solid";

// Assets
import HeroBg from "../../assets/images/compressed-images/twilight_sky.jpg";

const container = {
  hidden: { opacity: 1, scale: 1 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      delayChildren: 0.3,
      staggerChildren: 0.2,
      duration: 0.25,
    },
  },
};

const item = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
  },
};

const Hero = () => {
  return (
    <section
      className="relative flex justify-center items-center overflow-hidden"
      style={{
        height: "calc(100vh - var(--header-height, 80px))",
        backgroundImage: `url(${HeroBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-black/30" aria-hidden="true" />

      <motion.div
        variants={container}
        initial="hidden"
        animate="visible"
        className="relative z-10 flex flex-col gap-2 sm:gap-4 md:gap-6 mx-auto px-4 py-6 text-center max-w-3xl w-full"
      >
        <motion.div variants={item} className="font-bold text-white">
          <h1 className="text-3xl sm:text-5xl lg:text-6xl leading-tight mb-2 sm:mb-4">
            Build. <span className="text-white-700">Better.</span>
          </h1>
          <h2 className="text-base sm:text-xl md:text-2xl lg:text-3xl leading-tight">
            We deliver sustainable business outcomes through technology.
          </h2>
        </motion.div>

        <motion.p
          variants={item}
          className="text-white text-xs sm:text-sm md:text-base lg:text-lg leading-relaxed"
        >
          <span className="text-white-700 font-semibold">RAVL</span> is a
          boutique advisory and engineering firm delivering sustainable business
          outcomes through technology. With deep roots in North America’s
          leading financial services institutions and top global consulting and
          engineering firms, our team brings decades of experience delivering
          solutions that work in the real world, not just on paper.
          <span className="block mt-1 sm:mt-2 mb-1 sm:mb-2 text-white-700">
            Our mission is to be a true partner to our clients by{" "}
            <span className="text-white-700 font-semibold">
              building better technology that drives meaningful, long-lasting
              business outcomes.
            </span>
          </span>
          <span className="block text-white-700 font-semibold">
            RAVL Builds. Better
          </span>
        </motion.p>
        {/* <motion.p variants={item} className="text-purple-700 sm:text-xl">
          Build. Better.
        </motion.p> */}
        <motion.div variants={item} className="flex flex-wrap justify-center">
          <a
            href="#RAVL-Offerings"
            className="btn-primary flex items-center justify-center shadow-md text-base w-3/4 md:w-[45%] gap-4"
          >
            Learn More <ArrowRightIcon className="h-4" />
          </a>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;
